import {Fragment} from "react";
import {css} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {PercentIcon, UnlockIcon} from "@pg-design/icons-module";
import {Highlight} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {LeadModalStep} from "../../application/types/LeadModalStep";
import {DetailViewHeader} from "../../atoms/DetailViewHeader";
import {LinkWithLabel} from "../../atoms/LinkWithLabel";
import {IBoosterClickHandlerParams} from "../../boosters/types/IBoosterClickHandlerParams";
import {FavoriteButton} from "../../favorite/components/FavoriteButton";
import {DetailHeaderDropdownMenu} from "../../offer/components/DetailHeaderDropdownMenu";
import {useOfferLink} from "../../offer/detail/hooks/use_offer_link";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {HeaderCta} from "../../real_estate/components/HeaderCta";
import {Country} from "../../region/types/Country";
import {IPropertyDetailPromotion} from "../actions/fetch_property_detail_promotions";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {isPropertyFavouriteButtonAvailable} from "../utils/is_property_favourite_button_available";
import {isPropertyForSale} from "../utils/is_property_for_sale";
import {PropertyDetailHeaderPrice} from "./PropertyDetailHeaderPrice";
import {PropertyDetailHeaderPriceNegotiation} from "./PropertyDetailHeaderPriceNegotiation";

interface IProps {
    property: IPropertyDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick: (params: IBoosterClickHandlerParams) => void;
    onLocationClick: () => void;
}

const roomPlural = pluralize(["pokój", "pokoje", "pokoi"]);

export const PropertyDetailHeader = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();

    const isApartment = property.offer.is_holiday_location || property.offer.is_condohotel;
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    const isAbroad = property.offer.region.country && property.offer.region.country !== Country.POLAND;

    const offerLink = useOfferLink(property.offer);
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: property.offer.vendor.slug, vendorId: property.offer.vendor.id});

    const isPriceButtonAvailable = isPropertyForSale(property);
    const isFavouriteButtonAvailable = isPropertyFavouriteButtonAvailable(property);

    return (
        <div className={wrapper}>
            <DetailViewHeader
                address={property.offer.address}
                badges={
                    <Fragment>
                        {property.is_promo && (
                            <Badge variant="label_info" icon={PercentIcon}>
                                Promocja
                            </Badge>
                        )}

                        {property.is_reserved && (
                            <Badge variant="label_warning" icon={UnlockIcon}>
                                Rezerwacja
                            </Badge>
                        )}

                        {(!property.for_sale || !isPublished) && <Badge variant="label_secondary">Oferta archiwalna</Badge>}

                        {/* Due to CU-8693ecg7r temporary commented - program "Kredyt 2%" has ended at the begging of 2024 */}
                        {/*{property.credit_two_percent && isPublished && (*/}
                        {/*    <Badge variant="label_highlight" icon={MegaphoneIcon}>*/}
                        {/*        Kredyt 2%*/}
                        {/*    </Badge>*/}
                        {/*)}*/}
                    </Fragment>
                }
                cta={
                    <HeaderCta>
                        {!isMobile && isPriceButtonAvailable && <PropertyDetailHeaderPrice property={property} />}

                        {!isMobile && isFavouriteButtonAvailable && (
                            <FavoriteButton offer={property.offer} property={property} display={{type: "button", size: "l"}} />
                        )}
                        <DetailHeaderDropdownMenu />
                    </HeaderCta>
                }
                externalLinks={
                    <>
                        <LinkWithLabel href={offerLink} label="Inwestycja:" linkText={property.offer.name} />
                        {property.offer.investor ? (
                            <LinkWithLabel label="Inwestor:" linkText={property.offer.investor} />
                        ) : (
                            <LinkWithLabel href={vendorLink} label="Deweloper:" linkText={property.offer.vendor.name} />
                        )}
                    </>
                }
                onLocationClick={props.onLocationClick}
                title={
                    <div className={title}>
                        <div>
                            {isApartment ? "Apartament" : getOfferTypeNameCapital(property.offer.type)} na sprzedaż{" "}
                            <Highlight>
                                {property.rooms} {roomPlural(property.rooms)} o powierzchni {areaFormat(property.area, {precision: 2})} - numer{" "}
                                {property.number}
                            </Highlight>
                        </div>
                        <PropertyDetailHeaderPriceNegotiation
                            property={property}
                            initialStep={!isAbroad ? LeadModalStep.APPLICATION_FORM_WITH_NEGOTIATION : undefined}
                        />
                    </div>
                }
            />
        </div>
    );
};

const title = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: 2
});

const wrapper = css({
    display: "flex",
    position: "relative",
    flexWrap: "wrap",

    "@media (max-width: 1023px)": {
        marginBottom: "20px"
    }
});
import {Fragment} from "react";
import {css} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {PercentIcon, UnlockIcon} from "@pg-design/icons-module";
import {Highlight} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat, pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {LeadModalStep} from "../../application/types/LeadModalStep";
import {DetailViewHeader} from "../../atoms/DetailViewHeader";
import {LinkWithLabel} from "../../atoms/LinkWithLabel";
import {IBoosterClickHandlerParams} from "../../boosters/types/IBoosterClickHandlerParams";
import {FavoriteButton} from "../../favorite/components/FavoriteButton";
import {DetailHeaderDropdownMenu} from "../../offer/components/DetailHeaderDropdownMenu";
import {useOfferLink} from "../../offer/detail/hooks/use_offer_link";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {HeaderCta} from "../../real_estate/components/HeaderCta";
import {Country} from "../../region/types/Country";
import {IPropertyDetailPromotion} from "../actions/fetch_property_detail_promotions";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {isPropertyFavouriteButtonAvailable} from "../utils/is_property_favourite_button_available";
import {isPropertyForSale} from "../utils/is_property_for_sale";
import {PropertyDetailHeaderPrice} from "./PropertyDetailHeaderPrice";
import {PropertyDetailHeaderPriceNegotiation} from "./PropertyDetailHeaderPriceNegotiation";

interface IProps {
    property: IPropertyDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick: (params: IBoosterClickHandlerParams) => void;
    onLocationClick: () => void;
}

const roomPlural = pluralize(["pokój", "pokoje", "pokoi"]);

export const PropertyDetailHeader = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();

    const isApartment = property.offer.is_holiday_location || property.offer.is_condohotel;
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    const isAbroad = property.offer.region.country && property.offer.region.country !== Country.POLAND;

    const offerLink = useOfferLink(property.offer);
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: property.offer.vendor.slug, vendorId: property.offer.vendor.id});

    const isPriceButtonAvailable = isPropertyForSale(property);
    const isFavouriteButtonAvailable = isPropertyFavouriteButtonAvailable(property);

    return (
        <div className={wrapper}>
            <DetailViewHeader
                address={property.offer.address}
                badges={
                    <Fragment>
                        {property.is_promo && (
                            <Badge variant="label_info" icon={PercentIcon}>
                                Promocja
                            </Badge>
                        )}

                        {property.is_reserved && (
                            <Badge variant="label_warning" icon={UnlockIcon}>
                                Rezerwacja
                            </Badge>
                        )}

                        {(!property.for_sale || !isPublished) && <Badge variant="label_secondary">Oferta archiwalna</Badge>}

                        {/* Due to CU-8693ecg7r temporary commented - program "Kredyt 2%" has ended at the begging of 2024 */}
                        {/*{property.credit_two_percent && isPublished && (*/}
                        {/*    <Badge variant="label_highlight" icon={MegaphoneIcon}>*/}
                        {/*        Kredyt 2%*/}
                        {/*    </Badge>*/}
                        {/*)}*/}
                    </Fragment>
                }
                cta={
                    <HeaderCta>
                        {!isMobile && isPriceButtonAvailable && <PropertyDetailHeaderPrice property={property} />}

                        {!isMobile && isFavouriteButtonAvailable && (
                            <FavoriteButton offer={property.offer} property={property} display={{type: "button", size: "l"}} />
                        )}
                        <DetailHeaderDropdownMenu />
                    </HeaderCta>
                }
                externalLinks={
                    <>
                        <LinkWithLabel href={offerLink} label="Inwestycja:" linkText={property.offer.name} />
                        {property.offer.investor ? (
                            <LinkWithLabel label="Inwestor:" linkText={property.offer.investor} />
                        ) : (
                            <LinkWithLabel href={vendorLink} label="Deweloper:" linkText={property.offer.vendor.name} />
                        )}
                    </>
                }
                onLocationClick={props.onLocationClick}
                title={
                    <div className={title}>
                        <div>
                            {isApartment ? "Apartament" : getOfferTypeNameCapital(property.offer.type)} na sprzedaż{" "}
                            <Highlight>
                                {property.rooms} {roomPlural(property.rooms)} o powierzchni {areaFormat(property.area, {precision: 2})} - numer{" "}
                                {property.number}
                            </Highlight>
                        </div>
                        <PropertyDetailHeaderPriceNegotiation
                            property={property}
                            initialStep={!isAbroad ? LeadModalStep.APPLICATION_FORM_WITH_NEGOTIATION : undefined}
                        />
                    </div>
                }
            />
        </div>
    );
};

const title = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: 2
});

const wrapper = css({
    display: "flex",
    position: "relative",
    flexWrap: "wrap",

    "@media (max-width: 1023px)": {
        marginBottom: "20px"
    }
});
